import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Login } from './Login';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, isAdmin } = useAuth();

  if (!isAuthenticated) {
    return <Login isAdmin={requireAdmin} />;
  }

  if (requireAdmin && !isAdmin) {
    return <Login isAdmin={true} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;